<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import CatalystApp from 'Catalyst/components/CatalystApp/CatalystApp.svelte';
  import Icon from 'Catalyst/components/Icon/Icon.svelte';
  export let EndAt: string;

  let now = Date.now();
  let intervalId: number | null = null;

  $: endDate = new Date(EndAt);

  $: isValidEndDate = endDate instanceof Date && !isNaN(endDate.getTime());

  $: totalSeconds = isValidEndDate
    ? Math.max(0, Math.round((endDate.getTime() - now) / 1000))
    : 0;

  $: d = Math.floor(totalSeconds / (60 * 60 * 24));
  $: remainingSecondsAfterDays = totalSeconds % (60 * 60 * 24);
  $: h = Math.floor(remainingSecondsAfterDays / (60 * 60));
  $: remainingSecondsAfterHours = remainingSecondsAfterDays % (60 * 60);
  $: m = Math.floor(remainingSecondsAfterHours / 60);
  $: s = remainingSecondsAfterHours % 60;

  $: formattedTime = formatCountdown(totalSeconds, d, h, m, s);

  const padValue = (value: number): string => value.toString().padStart(2, '0');

  const formatCountdown = (
    totalSec: number,
    days: number,
    hours: number,
    minutes: number,
    seconds: number
  ): string => {
    if (totalSec <= 0) {
      return '00 hrs 00 mins 00 secs';
    }

    const parts: string[] = [];

    if (days > 0) {
      parts.push(`${days} days`);
    }

    parts.push(`${padValue(hours)} hrs`);
    parts.push(`${padValue(minutes)} mins`);
    parts.push(`${padValue(seconds)} secs`);

    return parts.join(' ');
  };

  onMount(() => {
    now = Date.now();

    intervalId = setInterval(() => {
      now = Date.now();
    }, 1000) as unknown as number;
  });

  onDestroy(() => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  });
</script>

<CatalystApp>
  <div
    class="flex items-center gap-2 text-gray-400 rounded-[1.5rem] border !border-[--palettes-brand-color-500] px-[1rem] py-[0.25rem]"
    data-testid="tiers-countdown"
  >
    <Icon name="clock_loader_10" />
    <span
      class="text-[0.75rem] font-[Inter] font-semibold leading-[1.25rem] text-[--palettes-brand-color-400] tabular-nums whitespace-nowrap"
    >
      {#if isValidEndDate}
        {formattedTime}
      {:else}
        0 days 00 hrs 00 mins 00 secs
      {/if}
    </span>
  </div>
</CatalystApp>
